import React from 'react';
import HeaderItem from '../HeaderItem';
import { useAppStore } from '../../../context/AppContext';
import { SidePanelModulEnum } from '../../../enums/sidePanelModulEnum';

const SettingsComponent: React.FC = () => {
    const { setVisibleSidePanelModuleIndex } = useAppStore();

    const itemClicked = () => () => {
        setVisibleSidePanelModuleIndex(SidePanelModulEnum.Settings);
    };

    return <HeaderItem title={'Settings'} iconName={'cog'} path={''} onItemClick={itemClicked()} />;
};

export default SettingsComponent;
